import { format, parse, setHours, setMinutes } from 'date-fns'

// Helper function to try parsing with multiple formats
const tryParseTime = (time: string, formats: string[]): Date | undefined => {
  for (const formatStr of formats) {
    const parsedDate = parse(time, formatStr, new Date())
    if (!isNaN(parsedDate.getTime())) {
      return parsedDate
    }
  }

  return undefined
}

export const formatTimeTo12Hour = (time: null | string | undefined) => {
  if (!time) return ''
  // Define the formats you want to support
  const formatsToTry = ['HH:mm', 'HH:mm:ss']

  // Try parsing the time with the supported formats
  const date = tryParseTime(time, formatsToTry)

  // If no valid date is found, return an empty string
  if (!date) return ''

  // Format the date in 12-hour format
  return format(date, 'hh:mm a')
}

export const formatTimeTo24Hour = (time: string, period: '' | 'AM' | 'am' | 'PM' | 'pm') => {
  const [hours, minutes] = time.split(':').map(Number)
  const adjustedHours =
    period === 'PM' && hours < 12 ? hours + 12 : period === 'AM' && hours === 12 ? 0 : hours
  const date = setMinutes(setHours(new Date(), adjustedHours), minutes)
  return format(date, 'HH:mm')
}
